import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import FieldController from './FieldController';
import CountryCodes from '../util/CountryCode';
import RegEx from '../util/RegEx';
import Util from '../util/Util';

class ModelController {

  static Staff = 'responsible_person';

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let model ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        model[keys[i]] = '';
        if(val === 'today') {
          model[keys[i]] = new Date();
        }
      } else if(fieldType === Const.Address) {
        model[keys[i]] = [{}];
      } else if(keys[i] === ModelController.Staff && fieldType.includes(Const.MultiSelect)) {
        const options = FieldController.getOptions(fields[keys[i]]);
        model[keys[i]] = options.filter(item => item.value === user);
      } else if(keys[i] === ModelController.Staff && fieldType.includes(Const.Select)) {
        const options = FieldController.getOptions(fields[keys[i]]);
        model[keys[i]] = options.find(item => item.value === user);
      } else if(fieldType.includes(Const.MultiSelect)) {
        model[keys[i]] = [];
        if(val && val !== '') {
          model[keys[i]] = '~' + val.replace(',', '~') + '~';
          model[keys[i]] = [];
        }
      } else if(fieldType.includes(Const.Phone)) {
        model[keys[i]] = [{ code: CountryCodes.find(item => item.value === '+91'), phone: ''}];
      } else if(fieldType.includes(Const.Email) || fieldType.includes(Const.MultiValue)) {
        model[keys[i]] = [''];
      } else {
        model[keys[i]] = val;
      }
    }
    return model;
  }

  static getModelFromServer = (fields, serverModel) => {
    const cities = reactLocalStorage.getObject(Const.Cities);
    const states = reactLocalStorage.getObject(Const.States);
    const countries = reactLocalStorage.getObject(Const.Countries);

    const model = { };
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const value = serverModel[key];
      const fieldType = fields[key].field_type;
      if(fieldType === Const.Toggle) {
        model[key] = value === Const.True;
      } else if(fieldType === Const.Date || fieldType === Const.DateTime) {
        model[key] = value ? Util.serverStringDateTimeToDate(value) : null;
      } else if(fieldType.includes(Const.MultiSelect)) {
        if(key == 'property'){
          let val = value;
          val = val && val !== '~~' ? val.substring(1, val.length - 1).split(Const.Opt) : [];
          model[key] = val.filter(v => v !== '');
        } else {
          const options = FieldController.getOptions(fields[key]);
          model[key] = value
            ? options.filter(option => value.includes(Const.Opt + option.value + Const.Opt))
            : null;
        }
      } else if(fieldType.includes(Const.Select)) {
        const options = FieldController.getOptions(fields[key]);
        model[key] = value ? options.find(option => value === option.value) : null;
      } else if(fieldType.includes(Const.Phone)) {
        model[key] = value && value.length > 2 
          ? value.substring(1, value.length - 1).split(Const.Opt)
            .map(item => {
              let code = CountryCodes.find(item => item.value === '+91');
              let phone = '';
              if(item.includes(Const.Hhn)) {
                const tmp = item.split(Const.Hhn);
                code = CountryCodes.find(item => item.value === tmp[0]);
                phone = tmp[1];
              } else {
                phone = item;
              } 
              return { code, phone };
            })
          : [{ code: CountryCodes.find(item => item.value === '+91'), phone: ''}];
      } else if(fieldType.includes(Const.Email) || fieldType.includes(Const.MultiValue)) {
        model[key] = value && value.length > 2 
          ? value.substring(1, value.length - 1).split(Const.Opt)
          : [ '' ];
      } else if(fieldType === Const.Address) {
        model[key] = value && value.length > 0 
          ? value.filter(address => 
              address.street || address.city || address.state || address.country || address.pin
            ).map(address => { 
              return {
                street: address.street,
                city: address.city
                  ? cities.find(city => city.value === parseInt(address.city))
                  : null,
                state: address.state
                  ? states.find(state => state.value === parseInt(address.state))
                  : null,
                country: address.country
                  ? countries.find(country => country.value === parseInt(address.country))
                  : null,
                pin: address.pin
              };
            })
          : [{}];
        model[key] = model[key] && model[key].length !== 0 ? model[key] : [{}];
      } else {
        model[keys[i]] = value;
      }
    }
    return model;
  }

  static getServerModel = (fields, stateModel) => {
    const model = { };
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      const value = stateModel[keys[i]];
      const fieldType = fields[keys[i]].field_type;

      if(fieldType === Const.Toggle) {
        model[keys[i]] = value ? Const.True : Const.False;
      } else if(fieldType === Const.Date || fieldType === Const.DateTime) {
        model[keys[i]] = value ? Util.dateToServerDateTime(value) : '';
      } else if(fieldType.includes(Const.MultiSelect)) {
        model[keys[i]] = value && value.length > 0 
          ? Const.Opt + value.map(option => option.value).join(Const.Opt) + Const.Opt
          : '';
      } else if(fieldType.includes(Const.Select)) {
        model[keys[i]] = value ? value.value : 0;
      } else if(fieldType.includes(Const.Phone)) {
        model[keys[i]] = value && value.length > 0 
          ? Const.Opt 
            + value.map(item => (item.code ? item.code.value : '') + Const.Hhn + item.phone) 
              .join(Const.Opt) 
            + Const.Opt
          : '';
      } else if(fieldType.includes(Const.Email) || fieldType.includes(Const.MultiValue)) {
        model[keys[i]] = value && value.length > 0 
          ? Const.Opt + value.join(Const.Opt) + Const.Opt
          : '';
      } else if(fieldType === Const.Address) {
        model[keys[i]] = value && value.length > 0 
          ? value.map(address => { 
              return {
                street: address.street,
                city: address.city ? address.city.value : 0,
                state: address.state ? address.state.value : 0,
                country: address.country ? address.country.value : 0,
                pin: address.pin
              };
            })
          : [];
      } else {
        model[keys[i]] = value;
      }
    }
    return model;
  }

  static validate = (fields, ConditionalFields, model) => {
    const keys = Object.keys(fields);
    let inValid = null;
    for(let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const type = fields[key].field_type;
      const ConditionalField = ConditionalFields.find(ConditionalField => ConditionalField.field === key);
      const mandatory = ConditionalField ? ConditionalField.mandatory : fields[key].form_mandate;
      const validate = fields[key].validate;

      if (type === Const.Address) {
        if(mandatory && model[key].length === 0) inValid = ModelController.result(key, inValid);
        let i = 0;
        let notEmpty = 0;
        for(; i < model[key].length; i++) {
          const address = model[key][i];
          if((!address.street || address.street.trim() !== '') 
            || (!address.city || parseInt(address.city) !== 0)
            || (!address.state || parseInt(address.state) !== 0)
            || (!address.country || parseInt(address.country) !== 0)
            || (!address.pin || address.pin.trim() !== '')) {
            notEmpty++;
          }
        }
        if(mandatory && notEmpty === 0) inValid = ModelController.result(key, inValid);
      } else if (type === Const.SinglePhone) {
        if(mandatory && (model[key] === '' || model[key] === '~~'))
          inValid = ModelController.result(key, inValid);
         continue;
      } else if (type === Const.Phone) {
        const phones = model[key] && model[key].length > 2 
          ? model[key].substring(1, model[key].length - 1).split(Const.Opt)
            .map(item => item.includes(Const.Hhn) ? item.split(Const.Hhn)[1].trim() : item.trim())
            .filter(item => item)
          : null;
        if(mandatory && (!phones || phones.length === 0)) {
          inValid = ModelController.result(key, inValid);
        }
        continue;
      } else if (type === Const.MultiValue || type === Const.Phone || type === Const.Email) {
        if(mandatory && (model[key] === '' || model[key] === '~~')) {
          inValid = ModelController.result(key, inValid);
        }
        continue;
      } else if (type.includes(Const.MultiSelect)) {
        if(validate.includes('multi') && validate.includes('false')) {
          const tmp = model[key] && model[key].length > 2 
            ? model[key].substring(1, model[key].length - 1).split('~') : [];
          if(tmp && tmp.length > 1) {
            inValid = ModelController.result(key, inValid);
          }
        } else if(mandatory && (model[key] === '' || model[key] === '~~')) {
          inValid = ModelController.result(key, inValid);
        }
      } else {
        if(!RegEx.isMatch(model[key], mandatory, validate)) {
          inValid = ModelController.result(key, inValid);
        }
      }
    }
    return inValid;
  }

  static result = (key, inValid) => {
    let tmpValid = inValid === null ? {} : inValid;
    tmpValid[key] = 'Invalid Data';
    return tmpValid;
  }

  static setError = (error, ConditionalFields) => {
    const keys = Object.keys(error);
    for(let i = 0; i < keys.length; i++) {
      const ConditionalField = ConditionalFields
        .find(ConditionalField => ConditionalField.field === keys[i]);
      if(ConditionalField) {
        ConditionalField.error = true;
        ConditionalField.errorMessage = error[keys[i]];
      }
    }
  }
}
export default ModelController;